import { Card } from "primereact/card";
import { Image } from "primereact/image";
import { useEffect, useState } from "react";
import {
    GetServiceErrors,
    GetServiceStatus
} from "../services/GetServiceStatus";
import { IServiceCard } from "../types/IServiceCard";
import { Skeleton } from "primereact/skeleton";
import { Spinner } from "@idwal/idwal-react-components";
import { IServiceEvent } from "../types/IServiceEvent";
import { useNavigate } from "react-router-dom";
import { EventCardFooter } from "./EventCardFooter";

/**
 * Service card component
 */
export const MainServiceCard = ({ serviceGroup }: IServiceCard) => {
    const [serviceData, setServiceData] = useState<IServiceEvent[] | null>(
        null
    );
    const [errors, setErrors] = useState<IServiceEvent[] | null>(null);
    const navigate = useNavigate();
    useEffect(() => {
        getData();
        const interval = setInterval(function () {
            getData();
        }, 60000);
        async function getData() {
            const data = await GetServiceStatus(serviceGroup.id);
            setServiceData(data);
            const eventErrors = GetServiceErrors(data);
            setErrors(eventErrors);
        }
        return () => clearInterval(interval);
    }, []);

    function openService() {
        navigate(`service/${serviceGroup.id}`);
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function subServiceLinkClick(e: any, subService: string) {
        e.stopPropagation();
        navigate(`service/${serviceGroup.id}/sub-service/${subService}`);
    }

    return (
        <Card
            onClick={openService}
            className="service-card cursor-pointer h-full mt-4"
            title={serviceGroup.name}
            footer={<EventCardFooter errors={errors} events={serviceData} />}
        >
            <div className="flex pt-1">
                <div style={{ width: 50, minWidth: 50 }}>
                    <Image
                        src={serviceGroup.icon}
                        width="50"
                        alt="Service image"
                    />
                </div>

                <div className="flex flex-grow-1 flex-wrap pl-2 md:pl-6 h-full">
                    {serviceGroup.services.map((service) => {
                        return (
                            <div
                                key={service.name}
                                className="flex align-items-center h-full mr-4 mb-3"
                            >
                                {serviceData ? (
                                    <div
                                        style={{
                                            width: 15,
                                            height: 15,
                                            backgroundColor:
                                                errors &&
                                                errors.length > 0 &&
                                                errors.find((error) => {
                                                    return (
                                                        error.serviceKey ===
                                                        service.name
                                                    );
                                                })
                                                    ? "red"
                                                    : "green",
                                            borderRadius: "50%"
                                        }}
                                    ></div>
                                ) : (
                                    <Skeleton
                                        shape="circle"
                                        size="1rem"
                                        borderRadius="100%"
                                    ></Skeleton>
                                )}
                                <small className="pl-1">
                                    <a
                                        onClick={(e) =>
                                            subServiceLinkClick(e, service.name)
                                        }
                                        className="service-link"
                                    >
                                        {service.name}
                                    </a>
                                </small>
                            </div>
                        );
                    })}
                </div>

                <div
                    style={{ width: 100, marginTop: -10 }}
                    className="justify-content-end flex justify-content-center align-items-center"
                >
                    {serviceData ? (
                        <div
                            style={{
                                backgroundColor:
                                    errors && errors.length > 0
                                        ? "var(--error-color)"
                                        : "var(--success-color)",
                                width: 50,
                                height: 50,
                                borderRadius: "50%",
                                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.12)",
                                transition: "all var(--transition-speed) ease"
                            }}
                            className={`flex justify-content-center align-items-center status-indicator ${
                                errors && errors.length > 0 ? "status-error" : "status-success"
                            }`}
                        >
                            <i
                                className={`pi ${
                                    errors && errors.length > 0
                                        ? "pi-times"
                                        : "pi-check"
                                }`}
                                style={{ 
                                    fontSize: "1.7em", 
                                    color: "white",
                                    textShadow: "0 1px 2px rgba(0, 0, 0, 0.2)"
                                }}
                            ></i>
                        </div>
                    ) : (
                        <Spinner width={50} height={50} />
                    )}
                </div>
            </div>
        </Card>
    );
};
